/**
 * List of all the modules that user can have access to. Contains only minimum information, so no security sensible info is exposed.
 * GotConfigurationForUser return only PermissionName, which then is filtered by the navbar
 * Even if user opens page that he has no access to, he will be redirected to the 403
 */
export const ALL_MODULES = [
    {
        Area: 'EN.Facts',
        PermissionName: 'EnFacts',
        ModuleConfigGroups: [
            {
                PermissionName: 'Account',
                ModuleConfigs: [
                    { PermissionName: 'EnFactsAccountInfoManagement', Url: '@EngineServer/EnFactsAccount' }
                ]
            },
            {
                PermissionName: 'EnTab',
                ModuleConfigs: [
                    { PermissionName: 'Protocols', Url: '@EngineServer/Protocols' },
                    { PermissionName: 'LicenseManagement', Url: '@EngineServer/Licenses' },
                    { PermissionName: 'ProtocolTemplates', Url: '@EngineServer/ProtocolTemplates' }
                ]
            },
            {
                PermissionName: 'RentalData',
                ModuleConfigs: [
                    { PermissionName: 'RentalDataSearch', Url: '@EngineServer/RentalData' },
                    { PermissionName: 'EnFactsCsvImport', Url: '@EngineServer/ImportManagement' }
                ]
            },
            {
                PermissionName: 'EnCount',
                ModuleConfigs: [
                    { PermissionName: 'EnPower_EnCount_web', Url: '@EngineServer/EnCountWeb' },
                    { PermissionName: 'EnCountMobile', Url: '@EngineServer/EnCountMobile' }
                ]
            }
        ]
    },
    {
        Area: 'EN.Power',
        PermissionName: 'EnPower',
        ModuleConfigGroups: [
            {
                PermissionName: 'CustomerPortal',
                ModuleConfigs: [
                    { PermissionName: 'EnPower_EnCrm_Customers', Url: '@EngineServer/EnPower/@EnPowerAccountId/EnCrm/BSP/Customers' },
                    { PermissionName: 'EnPower_EnCrm_Meters', Url: '@EngineServer/EnPower/@EnPowerAccountId/EnCount' },
                    { PermissionName: 'EnPower_EnVoice_Invoices', Url: '@EngineServer/EnPower/@EnPowerAccountId/EnVoice' },
                    { PermissionName: 'EnPower_EnVoice_AdvancePaymentInfos', Url: '@EngineServer/EnPower/@EnPowerAccountId/EnVoice/AdvancePaymentInfos' },
                    { PermissionName: 'InvoiceWarnings', Url: '@EngineServer/EnPower/@EnPowerAccountId/EnVoice/InvoiceWarnings' }
                ]
            },
            {
                PermissionName: 'Deliveries',
                ModuleConfigs: [
                    { PermissionName: 'EnPower_EnCrm_Contracts', Url: '@EngineServer/EnPower/@EnPowerAccountId/EnCrm/BSP/Contracts' },
                    { PermissionName: 'EnflowEnloc', Url: '@EngineServer/EnFlowExternal/EnFlowSwitcher' },
                    { PermissionName: 'EnFlow_SupplymentRequestReport', Url: '@EngineServer/EnFlow/SupplymentRequestReport' },
                    { PermissionName: 'Crm', Url: '@EngineServer/EnPower/@EnPowerAccountId/EnCrm/SupplymentConfigurations' },
                    { PermissionName: 'MarketPartnerContacts', Url: '@EngineServer/EnPower/@EnPowerAccountId/EnFlow/MarketPartnerContacts' },
                    { PermissionName: 'SupplymentRequestSearch', Url: '@EngineServer/EnPower/@EnPowerAccountId/SupplymentRequestSearch' },
                    { PermissionName: 'SupplymentManagement', Url: '@EngineServer/EnPower/@EnPowerAccountId/SupplymentManagement', IsBeta: true, DisabledInProd: true },
                    { PermissionName: 'MsconsCases', Url: '@EngineServer/EnPower/@EnPowerAccountId/MsconsCases/?IsDeleted_=No' }
                ]
            },
            {
                PermissionName: 'EnPowerTools',
                ModuleConfigs: [
                    { PermissionName: 'EnKeyCorrection', Url: '@EngineServer/EnPower/@EnPowerAccountId/EnKeyCorrection' },
                    { PermissionName: 'ChangeRequestManagement', Url: '@EngineServer/EnPower/@EnPowerAccountId/ChangeRequests' },
                    { PermissionName: 'KvasyActivities', Url: '@EngineServer/EnPower/@EnPowerAccountId/KvasyActivities' },
                    { PermissionName: 'DeliveryConfigurations', Url: '@EngineServer/EnPower/@EnPowerAccountId/EnVoice/SendConfiguration' },
                    { PermissionName: 'EnVoiceUpload', Url: '@EngineServer/EnPower/@EnPowerAccountId/EnVoice/Upload' },
                    { PermissionName: 'CustomerPermissions', Url: '@EngineServer/CustomerPermissions' },
                    { PermissionName: 'DeliveryProcessManagement', Url: '@EngineServer/DocumentDeliveryProcesses' }
                ]
            }
        ]
    },
    {
        Area: 'Administration',
        PermissionName: 'Admin',
        ModuleConfigGroups: [
            {
                PermissionName: 'UserAndAccounts',
                ModuleConfigs: [
                    { PermissionName: 'UserManagement', Url: '@EngineServer/Users' },
                    { PermissionName: 'EnFactsAccountManagement', Url: '@EngineServer/EnFactsAccounts' },
                    { PermissionName: 'EnPowerAccountManagement', Url: '@EngineServer/EnPowerAccounts' }
                ]
            },
            {
                PermissionName: 'Miscellaneous',
                ModuleConfigs: [
                    { PermissionName: 'Statistics', Url: '@EngineServer/Statistics' },
                    { PermissionName: 'ContractCenter', Url: '@EngineServer/EnPower/@EnPowerAccountId/ContractCenter' },
                    { PermissionName: 'AuditLogs', Url: '@EngineServer/AuditLogs' }
                ]
            }
        ]
    },
    {
        Area: 'Development',
        PermissionName: 'Development',
        ModuleConfigs: [
            { PermissionName: 'ComponentDoc', Url: '@EngineServer/ComponentDoc' }
        ]
    }
];
